<div class="ajax-loading"><div class="loading-icon"></div></div>
<section class="page-title">
    <h1>TRAIN OPERATING COMPANY</h1>
    <div class="employee-code">
        <button *hasPermission="['trainoperatingcompany.write']" mat-raised-button mat-raised-button color="primary" class="oms-btn pull-right" (click)="openTOCDialog(tocModel)"> <img src="./assets/images/icon-user-add.svg" alt="">  Add Train Operating Company </button>
    </div>
</section>
<mat-card class="card-white mb-4 p-0 filter-section">
    <mat-card-title class="mb-0">
        <div class="card-white-title mb-0  cursor-pointer" [class.advanceSearchFilter]="isAdvanceSearchFilter" (click)="onDisplayFilter(null)">
            <div class="card-user-name"> <img src="./assets/images/icon-filter.svg" alt="">  Filter</div>
            <div class="office-hours">
                <a class="box-arrow" (click)="onDisplayFilter($event)" href="javascript:void(0);"></a>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content [hidden]="!isAdvanceSearchFilter">
        <div class="example-form">
            <ul class="filter-list">
                <li>
                  <div class="form-group">
                      <mat-label>Keyword</mat-label>
                        <mat-form-field class="example-full-width">
                          <input matInput [(ngModel)]="filterKey" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                          <button *ngIf="filterKey" matSuffix mat-icon-button aria-label="Clear" (click)="filterKey='';applyFilter('')">
                              <mat-icon>close</mat-icon>
                          </button>
                      </mat-form-field>
                  </div>
                </li>
                <li>
                  <div class="form-group">
                      <mat-label>Status</mat-label>
                      <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedOption">
                          <mat-radio-button value="1">Active</mat-radio-button>
                          <mat-radio-button value="2">Inactive</mat-radio-button>
                        </mat-radio-group>
                  </div>
                </li>
             </ul>
             <div class="filter-action">
                <button class="me-3 btn-outline-black " mat-raised-button color="primary" (click)="clearFilter()" > Clear </button>
                <button class=" btn-black" mat-raised-button color="primary" (click)="applyActiveFilter()" > Apply </button>
             </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-white matcardheight">
    <mat-card-content>
        <div class="stiky-table-container ps-table">
            <table class="list-table" mat-table matSort (matSortChange)="sortTOCs($event)" [matSortDisableClear]="true" [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header="name" *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.name}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="code">
                    <th mat-header-cell mat-sort-header="code" *matHeaderCellDef> Code </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.code}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell mat-sort-header="status" *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div class="form-group">
                            <mat-slide-toggle [disabled]="!isWritePermission" [(ngModel)]="element.isActive" (change)="onToggleChange($event, element.id)"></mat-slide-toggle>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="updatedAt">
                    <th mat-header-cell mat-sort-header="updatedAt" *matHeaderCellDef> Last Modified</th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{getDate(element.updatedOn)}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action" *hasPermission="['trainoperatingcompany.write']">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <ul class="action-items text-center">
                            <li class="view-link justify-content-center">
                                <a (click)="openTOCDialog(element)" class="me-3 pt-1" href="javascript:void(0)" title="Edit Train Operating Company"><img src="./assets/images/icon-edit.svg" alt=""> </a>
                            </li>
                        </ul>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <div *ngIf="dataSource.filteredData.length == 0" class="no-record-found text-center p-3">No record found.</div>
        <mat-paginator #paginator [pageSize]="pageSize" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
    </mat-card-content>
</mat-card>